// Base de chaque formule : labels, pitch, ids, et `maxModules` (sélection de
// modules prioritaires — propriété pédagogique, pas commerciale).
//
// ⚠️ Les économies (hours / weekends / price / deposit / remainder) ici sont des
// DÉFAUTS de repli uniquement. La source de vérité commerciale est désormais
// cohorte/phase-aware : `getFormulaEconomics(formulaId)` dans `brevetSlots.js`.
// Les écrans pricing/reco/carte DOIVENT overlay l'éco de la phase active via
// `resolveFormula(formulaId, economics)` ci-dessous — jamais lire `price`/
// `hours`/`weekends` bruts depuis cette constante.
export const BREVET_FORMULAS = {
    decouverte: {
        id: "decouverte",
        label: "Coup de pouce",
        hours: 4,
        weekends: 2,
        price: 48,
        deposit: 1,
        remainder: 47,
        maxModules: 3,
        pitch: "Pour tester l'approche Masteur.",
    },
    sprint: {
        id: "sprint",
        label: "Sprint",
        hours: 8,
        weekends: 4,
        price: 99,
        deposit: 1,
        remainder: 98,
        maxModules: 6,
        pitch: "Le plus choisi — cadre régulier sur plusieurs week-ends.",
    },
    intensif: {
        id: "intensif",
        label: "Intensif",
        hours: 16,
        weekends: 4,
        price: 199,
        deposit: 1,
        remainder: 198,
        maxModules: null, // tous les modules des matières
        pitch: "Samedi + dimanche, pour viser la mention TB.",
    },
}

export const BREVET_FORMULAS_LIST = [
    BREVET_FORMULAS.decouverte,
    BREVET_FORMULAS.sprint,
    BREVET_FORMULAS.intensif,
]

/**
 * Fusionne la base d'une formule (label / pitch / id / maxModules) avec les
 * économies cohorte-aware de la phase active. `economics` provient de
 * `getFormulaEconomics(formulaId)` (brevetSlots.js) ; passer `null` retombe sur
 * les défauts statiques de `BREVET_FORMULAS`.
 *
 * On garde la clé `hours` (= totalHours) et `weekends` pour ne rien casser chez
 * les consumers existants ; on expose en plus `hoursPerWeekend` pour les copies
 * "N WE × Xh".
 *
 * @returns un objet formule complet, ou `null` si `formulaId` inconnu.
 */
export const resolveFormula = (formulaId, economics = null) => {
    const base = BREVET_FORMULAS[formulaId]
    if (!base) return null
    if (!economics) return base
    return {
        ...base,
        hours: economics.totalHours,
        weekends: economics.weekends,
        hoursPerWeekend: economics.hoursPerWeekend,
        price: economics.price,
        deposit: economics.deposit,
        remainder: economics.remainder,
    }
}
